<form [formGroup]="notificationBannerForm">
  @if (loading) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <div class="pagehd section">Notification Banners</div>
  <div class="section p-col-3" style="padding: unset !important">
    <div class="banner-message-header">
      <div class="section-head">Program type</div>
    </div>
    <div class="banner-control">
      <p-select
        panelStyleClass="notification-banner-programtype-dropdown"
        [options]="programtypes"
        placeholder="Program Type"
        dataKey="selectedProgramType.programTypeID"
        optionLabel="programName"
        optionValue="programTypeID"
        (onChange)="onProgramTypeChange($event)"></p-select>
    </div>
  </div>
  <div class="section">
    <div class="banner-message-header">
      <div class="section-head">Banner message</div>
      <div class="section-head-sub-text">
        ({{ getLimit }} characters remaining)
      </div>
    </div>
    <textarea
      pTextarea
      class="banner-message-text"
      formControlName="bannerMessage"
      maxlength="560"></textarea>
    <div>{{ bannerMessageHelp }}</div>

    @if (isActive) {
      <div class="banner-status-message">
        <div class="ui-icon-warning"></div>
        <div>
          This banner is currently running, press Stop Banner to end or edit
          Banner message
        </div>
      </div>
    }

    <div class="banner-button-container">
      <button
        type="button"
        pButton
        class="banner-button-container ui-button-info"
        (click)="startStopBanner()"
        [disabled]="!isStartButton">
        {{ startStopText }}
      </button>
      <button
        type="button"
        pButton
        class="banner-button-container ui-button-info"
        (click)="updateBanner()"
        [disabled]="isUpdateButton">
        Update Banner
      </button>
    </div>
  </div>

  <div class="section">
    <app-notification-banner-history
      #notificationBannerHistory></app-notification-banner-history>
  </div>
</form>
